export function isYoutubeURL(url: string) {
  if (!url) {
    return false
  }
  return url.match(
    /^(https?:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie)\.(com|be)\/.+$/gm
  )
}

export function validateVideoURL(videoUrl: string) {
  if (!videoUrl) {
    return { success: false, message: 'Video URL is required' }
  }
  // if video not from youtube
  if (!isYoutubeURL(videoUrl)) {
    return { success: false, message: 'Video URL must be from Youtube' }
  }

  return { success: true, message: null }
}
